export const TABS = {
  OVERVIEW: 'overview',
  EMPLOYEES: 'employees',
  SPENDS: 'spends',
}
